import React from 'react';
import { motion } from 'framer-motion';
import { PenLine, Mic } from 'lucide-react';

export default function ModeChoiceButtons({ onSelectText, onSelectVoice }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
      className="flex flex-col sm:flex-row gap-3 mt-4"
      data-testid="mode-choice-buttons"
    >
      <button
        onClick={onSelectText}
        className="flex-1 flex items-center justify-center gap-3 px-6 py-4 bg-white border-2 border-blue-200 rounded-xl hover:border-blue-500 hover:bg-blue-50 transition-all shadow-sm hover:shadow-md group"
        data-testid="choose-text-mode"
      >
        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center group-hover:bg-blue-200 transition-colors">
          <PenLine className="w-5 h-5 text-blue-600" />
        </div>
        <span className="text-base font-medium text-slate-700">✍️ Schreiben</span>
      </button>
      
      <button
        onClick={onSelectVoice}
        className="flex-1 flex items-center justify-center gap-3 px-6 py-4 bg-white border-2 border-purple-200 rounded-xl hover:border-purple-500 hover:bg-purple-50 transition-all shadow-sm hover:shadow-md group"
        data-testid="choose-voice-mode"
      >
        <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center group-hover:bg-purple-200 transition-colors">
          <Mic className="w-5 h-5 text-purple-600" />
        </div>
        <span className="text-base font-medium text-slate-700">🎤 Sprechen</span>
      </button>
    </motion.div>
  );
}
